import React, { useEffect, useState } from "react";
import axios from "axios";
import AddMetaTags from './AddMetaTags';

const MetaTagsList = () => {
  const [metTag, setMetaTag] = useState([]);
  const [editMeta, setEditMeta] = useState(null); // State to hold the tag being edited

  useEffect(() => {
    async function getMetaData() {
      try {
        const res = await axios.get("https://api.plusdistribution.in/meta/get-meta");
        const allMetaTags = res.data.response.metaInf;
        setMetaTag(allMetaTags); // Set meta tags
      } catch (error) {
        console.error("Error fetching meta tags:", error);
      }
    }

    getMetaData();
  }, []);

  const addOrUpdateMetaTag = (newTag) => {
    const existingTagIndex = metTag.findIndex(tag => tag.site_name === newTag.site_name);

    if (existingTagIndex !== -1) {
      setMetaTag(prevTags =>
        prevTags.map((tag, index) =>
          index === existingTagIndex
            ? { ...tag, ...newTag }
            : tag
        )
      );
    } else {
      setMetaTag(prevTags => [
        ...prevTags,
        {
          site_id: Date.now(),
          site_name: newTag.site_name,
          meta_title: newTag.meta_title,
          meta_desc: newTag.meta_desc,
          meta_key: newTag.meta_key,
          meta_image: newTag.meta_image
        }
      ]);
    }
    setEditMeta(null);
  };

  const handleEdit = (tag) => {
    setEditMeta(tag);
  };

  return (
    <div>
      <AddMetaTags onMetaTagAdded={addOrUpdateMetaTag} editMeta={editMeta} />

      {metTag.length > 0 ? (
        <div className="overflow-auto">
          <table className="min-w-full bg-white border border-gray-200 mt-5">
            <thead>
              <tr>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Site Name</th>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Meta Title</th>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Meta Description</th>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Meta Keywords</th>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Meta Image</th>
                <th className="px-6 py-3 border-b text-left font-semibold text-black">Actions</th>
              </tr>
            </thead>
            <tbody>
              {metTag.map((tag) => (
                <tr key={tag.site_id}>
                  <td className="px-6 py-4 border-b text-black">{tag.site_name}</td>
                  <td className="px-6 py-4 border-b text-black">{tag.meta_title}</td>
                  <td className="px-6 py-4 border-b text-black">{tag.meta_desc}</td>
                  <td className="px-6 py-4 border-b text-black">{tag.meta_key}</td>
                  <td className="px-6 py-4 border-b text-black">
                    <img src={tag.meta_image} alt="Meta" style={{ width: "100px", height: "auto" }} />
                  </td>
                  <td className="px-6 py-4 border-b text-black">
                    <button onClick={() => handleEdit(tag)} className="text-blue-500 hover:underline">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p>No meta tags found</p>
      )}
    </div>
  );
};

export default MetaTagsList;
